// Heroes open on their poster, and the film arrives afterwards.
//
// The hero videos are 1.3MB and 1.7MB against posters of 22KB and 108KB. With
// `autoplay` and `preload="metadata"` in the markup the browser started pulling
// the film during page load, competing for the connection with the very image
// the page's LCP is measured against. On a phone that is seconds, and it was
// the single heaviest thing on the home page by a wide margin: 95% of the
// bytes.
//
// Both posters are stills from the first frame, so there is nothing to see at
// the moment playback takes over.
//
// Waiting for `load` rather than DOMContentLoaded is deliberate. The point is
// to keep the film off the network until everything the shopper actually looks
// at has arrived.
(() => {
  // The film plays on a phone too. It was held back below 750px for a while to
  // save the megabyte, and that is not the trade Alan wants: the hero is the
  // brand's own campaign film and a phone is where most people see it.
  //
  // Re-encoding was tried instead and did not help. At CRF 26 and 29 x264
  // produced files larger than the originals, and only aggressive denoising got
  // 23% off, which showed. These clips are already about as small as 15 seconds
  // of full-frame film gets.
  //
  // Deferring it past the load event is what actually mattered, and that is
  // below. The bytes are the same, they just stop competing with the poster the
  // page is measured on.
  const worthIt = () => {
    // Someone who has switched on data saver, or is on a 2G connection, has
    // asked for this in as many words. They keep the poster.
    const link = navigator.connection;
    if (link && (link.saveData || /^(slow-)?2g$/.test(link.effectiveType || ''))) return false;

    return true;
  };

  const start = () => {
    // Anyone who has asked their system for less motion keeps the still, and
    // the file is never fetched at all.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!worthIt()) return;

    for (const video of document.querySelectorAll('[data-hero-video], .js-hero-video')) {
      video.preload = 'auto';
      video.load();

      // A browser that refuses to autoplay leaves the poster up, which is a
      // perfectly good hero. Nothing to report.
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {});
    }
  };

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
